import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getCancelaciones } from '../../../../service/reportes/Cancelaciones';
import { getSelectUser } from '../../../../service/reportes/Activaciones';

export const useGetAll = (realoadGrid: number, filters: any) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getCancelaciones(filters)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, realoadGrid]);
  return { data, loadingRequest };
};

export const useSelectUser = (
  show: boolean,
  showFilterCode: boolean,
  type: number,
  noAuto: boolean = true
) => {
  const [data, setData] = useState<any[]>([]);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getSelectUser(type, noAuto);
        if (res) setData(res);
      } catch (error) {
        history.push('/error/500');
      }
    };

    if (type > 0 && show) {
      fetchPost();
    } else if (type === 0) {
      setData([]);
    }
  }, [type, show, noAuto]);

  return { data };
};
